import { AnalyticsStudio } from "./AnalyticsStudio";

/**
 * Simple-mode "Ask" — the consumer-facing wrapper around Analytics Studio.
 * Same NLQ engine underneath; the `simple` flag hides the schema browser,
 * tucks the query rationale behind a "Why this query?" disclosure, and
 * relabels Save → Pin. Pro users get the full Studio at /explore.
 */
export function Ask() {
  return <AnalyticsStudio simple />;
}
